import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Login",
  props: [],
  components: {},
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      uesrName: "",
      password: "",
      remember: false
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {
    // window.sessionStorage.setItem("userToken", "123123");
    if (this.userToken) {
      this.logout();
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: _objectSpread(_objectSpread({}, mapActions(["setUserToken", "setUserData", "logout"])), {}, {
    logining: function logining() {
      var _this = this;

      if (!this.uesrName || !this.password) {
        return;
      }

      this.loading = true; // window.sessionStorage.setItem("userToken", "");
      // window.location = "./";
      // this.loading = false;

      this.loading = true;
      this.$http.post("/web/login", this.$qs.stringify({
        username: this.uesrName,
        password: this.password
      })).then(function (res) {
        if (res.data.resCode === 0) {
          window.sessionStorage.setItem("userToken", res.data.resData.sid);

          _this.setUserToken(res.data.resData.sid);

          _this.$nextTick(function () {
            window.location = "./";
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  }),
  watch: {},
  filters: {}
};